import { ButtonPrimeReact, DropdownPrimeReact } from "@finanedi.es/storybook"
import { IconName } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Skeleton } from "antd"
import { getAlbaranById, getAlbaranPdfById } from "api/Albaran.service"
import { AlbaranReadingFiltersDtoProps } from "api/DTOs/AlbaranReadingFiltersDto"
import { FacturaReadingFiltersDtoProps } from "api/DTOs/FacturaReadingFiltersDto"
import { PedidoReadingFiltersDtoProps } from "api/DTOs/PedidoReadingFiltersDto"
import { getPedidoById, getPedidoPdfById } from "api/Pedido.service"
import {
  getPresupuestoById,
  getPresupuestoPdfById,
} from "api/Presupuesto.service"
import { AlbaranReadingFiltersDtoIPagedEnumerableProps } from "api/Schemas/AlbaranReadingFiltersDtoIPagedEnumerable"
import { FacturaReadingFiltersDtoIPagedEnumerableProps } from "api/Schemas/FacturaReadingFiltersDtoIPagedEnumerable"
import { PedidoReadingFiltersDtoIPagedEnumerable } from "api/Schemas/PedidoReadingFiltersDtoIPagedEnumerable"
import { DATE_DD_MM_YYYY } from "common/components/FilterMenu/constants"
import { formatCurrencyWithDecimal } from "common/utils/currency"
import { formatDate } from "common/utils/utils"
import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { capitalize } from "features/User/utils"
import { ArrayHelpers, FieldArray, withFormik } from "formik"
import { AnimatePresence, motion } from "framer-motion"
import { useAsociarDocumentos } from "hooks/useAsociarDocumentos"
import { TFunction } from "i18next"
import { Calendar } from "primereact/calendar"
import { Checkbox } from "primereact/checkbox"
import { InputNumber, InputNumberChangeParams } from "primereact/inputnumber"
import { InputText } from "primereact/inputtext"
import { ChangeEvent, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useInView } from "react-intersection-observer"
import ModalShowPdf from "../../../ModalShowPdf/ModalShowPdf"
import { ArticuloReadingSimpleDtoProps } from "../../Components/HeaderDocumento/HeaderDocumento"

type DocumentType = "factura" | "pedido" | "albaran"

// Luego puedes usar DocumentType para tipificar options
const options: Record<DocumentType, string[]> = {
  factura: [
    TYPES_DOCUMENTOS.PRESUPUESTO,
    TYPES_DOCUMENTOS.PEDIDO,
    TYPES_DOCUMENTOS.ALBARAN,
  ],
  albaran: [TYPES_DOCUMENTOS.PRESUPUESTO, TYPES_DOCUMENTOS.PEDIDO],
  pedido: [TYPES_DOCUMENTOS.PRESUPUESTO],
}

interface formaPago {
  description: string
  id: number | null
}

interface DropdownOption {
  id: number
  label: string
  icon: IconName
}

const dropdownOptions = (t: TFunction): DropdownOption[] => [
  { id: 0, label: t("crear.facturaRec.numberDoc"), icon: "file-lines" },
  { id: 1, label: t("crear.facturaRec.dateDocument"), icon: "calendar-clock" },
  { id: 2, label: t("crear.facturaRec.import"), icon: "coin" },
]

interface Documento {
  divisa: string
  estadoRevisionActual: number
  fechaEmision: string
  id: string
  importe: number
  motivo: string | null
  nifLibrado: string
  nifLibrador: string
  numero: number
  numeroFicherosAdjuntos: number
  paisLibrado: string
  paisLibrador: string
  razonSocialLibrado: string
  razonSocialLibrador: string
  serie: string
  tipoDocumento: number
}

interface DocumentosSeleccionados {
  showDocumentosSelected: boolean
  documentosSelectedIds: Documento[]
  showPdfModal: boolean
  selectDocument: string
}

interface OptionCurrentFilter {
  ImporteLowerLimit: number | null
  ImporteUpperLimit: number | null
}

const AsociarDocumento = ({
  values,
  setFieldValue,
  librado,
  librador,
  isVenta,
  onHide,
  valuesForm,
  handleSubmit,
  isSubmitting,
}: {
  values: DocumentosSeleccionados
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
  librado: string
  librador: string
  isVenta: boolean
  onHide: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  valuesForm: $TSMigrationFixMe
  handleSubmit: () => void
  isSubmitting: boolean
}) => {
  const { t } = useTranslation()
  const [serieNumero, setSerieNumero] = useState("")
  const [optionDateFilter, setOptionDateFilter] = useState<
    Date | Date[] | undefined
  >([])
  const [pdf, setPdf] = useState(null)
  const { ref, inView } = useInView()
  const [optionCurrentFilter, setOptionCurrentFilter] =
    useState<OptionCurrentFilter>({
      ImporteLowerLimit: null,
      ImporteUpperLimit: null,
    })
  const [optionFilter, setOptionFilter] = useState(0)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [dataElement, setDataElement] = useState<any>([])

  const itemTemplate = (option: DropdownOption) => {
    return (
      <div className='tw-flex tw-flex-row tw-h-12 tw-items-center !tw-p-0'>
        <FontAwesomeIcon
          icon={["fal", option.icon]}
          className='tw-w-6 tw-h-6 tw-mr-3'
        />
        <p className='tw-m-0'>{option.label}</p>
      </div>
    )
  }

  const valueTemplate = (option: {
    id: number
    label: string
    icon: IconName
  }) => {
    return (
      <FontAwesomeIcon
        icon={["fal", option.icon]}
        className='tw-w-6 tw-h-6 !tw-text-simple-10'
      />
    )
  }

  const fetchServicePdf = (documentType: string, id: string) => {
    switch (documentType) {
      case TYPES_DOCUMENTOS.PEDIDO:
        return getPedidoPdfById(id)
      case TYPES_DOCUMENTOS.ALBARAN:
        return getAlbaranPdfById(id)
      default:
        return getPresupuestoPdfById(id)
    }
  }

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useAsociarDocumentos({
      values,
      serieNumero,
      optionDateFilter,
      optionCurrentFilter,
      librado,
      librador,
      isVenta,
    })

  useEffect(() => {
    data &&
      setDataElement(
        data?.pages?.flatMap(
          (
            page:
              | PedidoReadingFiltersDtoIPagedEnumerable
              | AlbaranReadingFiltersDtoIPagedEnumerableProps
              | FacturaReadingFiltersDtoIPagedEnumerableProps
          ) =>
            page?.items?.map(
              (
                item:
                  | PedidoReadingFiltersDtoProps
                  | AlbaranReadingFiltersDtoProps
                  | FacturaReadingFiltersDtoProps
              ) => item
            ) ?? []
        )
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.pages])

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage()
    }
  }, [inView, hasNextPage, fetchNextPage])

  const handleDropdownOptions = (value: number) => {
    setOptionCurrentFilter({
      ImporteLowerLimit: null,
      ImporteUpperLimit: null,
    })
    setOptionDateFilter(undefined)
    setSerieNumero("")
    setOptionFilter(value)
  }

  const handleShowPdf = async (id: string) => {
    const { data } = await fetchServicePdf(values.selectDocument, id)
    setPdf(data)
    setFieldValue("showPdfModal", !values.showPdfModal)
  }

  return (
    <div className='!tw-h-fit tw-w-full tw-flex tw-flex-col'>
      <div className='tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-my-6'>
        <p className='tw-m-0 tw-text-xl tw-font-medium'>
          {t("crear.facturaRec.modal.associatedLabel")}
        </p>
        <div>
          <div className='tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
            <ButtonPrimeReact
              className='hover:!tw-shadow-md tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent hover:!tw-bg-neutral-10 tw-cursor-pointer'
              onClick={onHide}
            >
              {t("crear.facturaRec.modal.cancelButton")}
            </ButtonPrimeReact>
            <ButtonPrimeReact
              onClick={handleSubmit}
              loading={isSubmitting}
              disabled={!values.documentosSelectedIds.length}
              className='tw-shadow hover:!tw-shadow-md !tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-secondary hover:!tw-border-secondary-over !tw-w-48 tw-h-10 tw-flex tw-justify-center tw-items-center'
            >
              {t("crear.facturaRec.modal.associatedLabel")}
            </ButtonPrimeReact>
          </div>
        </div>
      </div>
      <div>
        <span>{t("crear.facturaRec.modal.selectTypeDocLabel")}</span>
        <div className='tw-w-full tw-flex tw-flex-row'>
          <div className='tw-w-1/2 tw-flex tw-row tw-justify-end'>
            <div className='tw-w-fit tw-flex tw-flex-row tw-p-1 tw-bg-neutral-10 tw-rounded'>
              {options?.[valuesForm?.documentoType?.type as DocumentType]?.map(
                (option: string) => (
                  <span
                    key={option}
                    onClick={() =>
                      !values.documentosSelectedIds.length &&
                      values.selectDocument !== option &&
                      setFieldValue("selectDocument", option)
                    }
                    className={`tw-px-3 tw-py-auto tw-flex tw-items-center ${
                      values.selectDocument === option
                        ? "tw-bg-simple-10 tw-font-medium"
                        : !values.documentosSelectedIds.length
                        ? "hover:!tw-bg-neutral-25 tw-cursor-pointer"
                        : "tw-cursor-not-allowed	"
                    } tw-rounded ${option !== "albaran" ? "tw-mr-1" : ""}`}
                  >
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </span>
                )
              )}
            </div>
          </div>
          <div className='tw-w-1/2 tw-h-11 tw-flex tw-flex-row tw-items-center'>
            <DropdownPrimeReact
              panelClassName='!tw-z-50 !tw-max-w-[600px]'
              value={optionFilter}
              placeholder={`${t("crear.documento.selectContact")}`}
              onChange={({ value }: { value: number }) =>
                handleDropdownOptions(value)
              }
              options={dropdownOptions(t)}
              optionValue='id'
              style={{ color: "#FFF" }}
              valueTemplate={valueTemplate}
              className='!tw-rounded-l !tw-rounded-r-none hover:!tw-shadow !tw-h-full !tw-max-w-full !tw-w-fit !tw-bg-primary !tw-text-simple-10 tw-border-1 tw-items-center tw-align-middle !tw-p-0 tw-m-0'
              itemTemplate={itemTemplate}
              scrollHeight='350px'
            />
            {optionFilter === 0 ? (
              <InputText
                value={serieNumero ?? ""}
                className='tw-w-full !tw-rounded-l-none tw-h-full'
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setSerieNumero(event.target.value)
                }
                placeholder={`${t("crear.facturaRec.numberDoc")}`}
              />
            ) : optionFilter === 1 ? (
              <Calendar
                className='tw-w-full tw-h-full'
                inputClassName='!tw-rounded-l-none'
                value={optionDateFilter}
                onChange={({ value }: { value: Date | Date[] | undefined }) =>
                  setOptionDateFilter(value)
                }
                selectionMode='range'
                readOnlyInput
                placeholder={`${t("crear.facturaRec.dateDocument")}`}
              />
            ) : (
              <div className='tw-w-full tw-h-full tw-flex tw-flex-row'>
                <InputNumber
                  value={optionCurrentFilter?.ImporteLowerLimit ?? undefined}
                  placeholder={`${t("crear.facturaRec.min")}`}
                  onChange={(e: InputNumberChangeParams) => {
                    setOptionCurrentFilter((prev) => ({
                      ...prev,
                      ImporteLowerLimit: e.value,
                    }))
                  }}
                  inputClassName='!tw-rounded-none'
                  className='!tw-w-1/2 tw-h-full'
                />
                <InputNumber
                  value={optionCurrentFilter?.ImporteUpperLimit ?? undefined}
                  placeholder={`${t("crear.facturaRec.max")}`}
                  onChange={(e: InputNumberChangeParams) =>
                    setOptionCurrentFilter((prev) => ({
                      ...prev,
                      ImporteUpperLimit: e.value,
                    }))
                  }
                  inputClassName='!tw-rounded-l-none'
                  className='!tw-w-1/2 tw-h-full'
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <ModalShowPdf
        pdf={pdf}
        onHide={() => setFieldValue("showPdfModal", !values.showPdfModal)}
        visible={values?.showPdfModal}
      />

      <AnimatePresence>
        {!values.showDocumentosSelected && (
          <div className='tw-w-full !tw-h-96 tw-mt-5 tw-bg-neutral-10'>
            {dataElement.length ? (
              <FieldArray name='documentosSelectedIds'>
                {({ push }: ArrayHelpers) => {
                  return (
                    <div className='tw-flex tw-flex-col tw-overflow-y-scroll tw-h-full tw-p-4'>
                      {dataElement.map(
                        (
                          item:
                            | PedidoReadingFiltersDtoProps
                            | FacturaReadingFiltersDtoProps
                            | AlbaranReadingFiltersDtoProps
                        ) => (
                          <div
                            key={item?.id}
                            className='tw-flex tw-flex-row !tw-h-[72px] tw-p-3 tw-px-5 tw-mb-3 tw-shadow-md tw-rounded tw-justify-between tw-items-center tw-bg-simple-10'
                          >
                            <Checkbox
                              checked={values.documentosSelectedIds.some(
                                (element: Documento) => item.id === element.id
                              )}
                              onChange={() => {
                                const isSelected =
                                  values.documentosSelectedIds.find(
                                    (element: Documento) =>
                                      item.id === element.id
                                  )

                                if (!isSelected) {
                                  push(item)
                                } else {
                                  setFieldValue(
                                    "documentosSelectedIds",
                                    values.documentosSelectedIds.filter(
                                      (element: Documento) =>
                                        item.id !== element.id
                                    )
                                  )
                                }
                              }}
                              className='tw-mr-2'
                            />
                            <div className='tw-flex tw-flex-col tw-mr-2'>
                              <span className='tw-font-medium'>
                                {t("crear.facturaRec.number")}
                              </span>
                              <p className='tw-mb-0'>
                                {item?.serie} - {item?.numero}{" "}
                              </p>
                            </div>
                            <div className='tw-flex tw-flex-col tw-mr-2 tw-max-w-80 tw-truncate'>
                              <span className='tw-font-medium'>
                                {t("crear.facturaRec.razonSocial")}
                              </span>
                              <p className='tw-mb-0'>
                                {item?.razonSocialLibrado}{" "}
                              </p>
                            </div>
                            <div className='tw-flex tw-flex-col tw-mr-2m tw-text-end'>
                              <span className='tw-font-medium'>
                                {t("crear.facturaRec.emisionDate")}
                              </span>
                              <p className='tw-mb-0'>
                                {formatDate(
                                  item?.fechaEmision,
                                  DATE_DD_MM_YYYY
                                )}
                              </p>
                            </div>
                            <div className='tw-flex tw-flex-col tw-mr-2 tw-text-end'>
                              <span className='tw-font-medium'>
                                {t("crear.facturaRec.headerImport")}
                              </span>
                              <p className='tw-mb-0'>
                                {formatCurrencyWithDecimal(item?.importe)}
                              </p>
                            </div>
                            <div
                              onClick={() =>
                                item?.id && handleShowPdf(item?.id)
                              }
                              className='hover:!tw-shadow-md tw-w-10 tw-h-10 tw-cursor-pointer tw-rounded tw-shadow tw-text-secondary hover:!tw-text-secondary-over tw-flex tw-justify-center tw-items-center'
                            >
                              <FontAwesomeIcon
                                icon={["fal", "eye"]}
                                className='tw-w-5 tw-h-5'
                              />
                            </div>
                          </div>
                        )
                      )}
                      {isFetchingNextPage && (
                        <Skeleton className='tw-w-full tw-h-10' />
                      )}
                      <div
                        ref={ref}
                        style={{ height: "20px", background: "transparent" }}
                      />
                    </div>
                  )
                }}
              </FieldArray>
            ) : (
              <div className='tw-flex tw-justify-center tw-items-center tw-h-full tw-p-4 tw-mt-5'>
                {t("crear.facturaRec.modal.notWantedDocMsg")}
              </div>
            )}
          </div>
        )}

        <motion.div
          layout
          onClick={() =>
            setFieldValue(
              "showDocumentosSelected",
              !values.showDocumentosSelected
            )
          }
          title={`${t("crear.facturaRec.modal.showDocSelected")}`}
        >
          <div
            className={`tw-flex tw-justify-center tw-items-center tw-flex-col tw-p-6 tw-bg-simple-10 tw-w-full tw-shadow !tw-h-12 ${
              values.showDocumentosSelected ? "tw-mt-5" : ""
            } tw-cursor-pointer`}
          >
            <span className='tw-rounded !tw-h-4 tw-w-12 tw-bg-neutral tw-border tw-mb-2' />
            <span className='tw-flex tw-flex-row tw-items-center tw-text-secondary hover:!tw-text-secondary-over'>
              {values.documentosSelectedIds.length}
              {t("crear.facturaRec.modal.selectedLabel")}{" "}
              <FontAwesomeIcon
                icon={[
                  "fal",
                  values.showDocumentosSelected ? "angle-down" : "angle-up",
                ]}
                className='tw-ml-2'
              />
            </span>
          </div>
        </motion.div>

        {values.showDocumentosSelected && (
          <FieldArray name='documentosSelectedIds'>
            {({ remove }: ArrayHelpers) => (
              <div className='tw-h-[400px]  tw-bg-neutral-10'>
                <div className='tw-flex tw-flex-col tw-h-full tw-overflow-y-scroll tw-p-4 '>
                  {values.documentosSelectedIds.length ? (
                    values.documentosSelectedIds.map(
                      (item: Documento, index: number) => (
                        <div
                          key={item?.id}
                          className='tw-flex tw-flex-row !tw-h-[72px] tw-p-3 tw-px-5 tw-mb-3 tw-shadow-md tw-rounded tw-justify-between tw-items-center tw-bg-simple-10'
                        >
                          <Checkbox
                            checked={values.documentosSelectedIds.some(
                              (element: Documento) => item.id === element.id
                            )}
                            onChange={() => remove(index)}
                            className='tw-mr-2'
                          />
                          <div className='tw-flex tw-flex-col tw-mr-2'>
                            <span className='tw-font-medium'>
                              {t("crear.facturaRec.number")}
                            </span>
                            <p className='tw-mb-0'>
                              {item?.serie} - {item?.numero}{" "}
                            </p>
                          </div>
                          <div className='tw-flex tw-flex-col tw-mr-2 tw-max-w-80 tw-truncate'>
                            <span className='tw-font-medium'>
                              {t("crear.facturaRec.razonSocial")}
                            </span>
                            <p className='tw-mb-0'>
                              {item?.razonSocialLibrado}{" "}
                            </p>
                          </div>
                          <div className='tw-flex tw-flex-col tw-mr-2m tw-text-end'>
                            <span className='tw-font-medium'>
                              {t("crear.facturaRec.emisionDateLabel")}
                            </span>
                            <p className='tw-mb-0'>
                              {formatDate(item?.fechaEmision, DATE_DD_MM_YYYY)}
                            </p>
                          </div>
                          <div className='tw-flex tw-flex-col tw-mr-2 tw-text-end'>
                            <span className='tw-font-medium'>
                              {t("crear.facturaRec.headerImport")}
                            </span>
                            <p className='tw-mb-0'>
                              {formatCurrencyWithDecimal(item?.importe)}
                            </p>
                          </div>
                          <div
                            onClick={() => handleShowPdf(item?.id)}
                            className='tw-w-10 tw-h-10 tw-cursor-pointer tw-rounded tw-shadow tw-text-secondary hover:!tw-text-simple-10 hover:tw-bg-secondary-75 tw-flex tw-justify-center tw-items-center'
                          >
                            <FontAwesomeIcon
                              icon={["fal", "eye"]}
                              className='tw-w-5 tw-h-5'
                            />
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <div className='tw-flex tw-justify-center tw-items-center tw-h-full tw-p-4'>
                      {t("crear.facturaRec.modal.notSelectedMsg")}
                    </div>
                  )}
                </div>
              </div>
            )}
          </FieldArray>
        )}
      </AnimatePresence>
    </div>
  )
}

const FormAsociarDocumento = withFormik({
  validateOnMount: true,
  enableReinitialize: true,
  mapPropsToValues: (props: {
    data: DocumentosSeleccionados
    formasPago: formaPago[]
    handleAddArticle: (newArticulos?: ArticuloReadingSimpleDtoProps[]) => void
    handleVariable: (
      field: string,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      value: $TSMigrationFixMe,
      shouldValidate?: boolean
    ) => Promise<void>
    isVenta: boolean
    librado: string
    librador: string
    onHide: () => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valuesForm: $TSMigrationFixMe
    type: string
  }) => ({
    showDocumentosSelected: props.data?.showDocumentosSelected ?? false,
    documentosSelectedIds: props.data?.documentosSelectedIds ?? [],
    showPdfModal: false,
    selectDocument: props.data?.selectDocument ?? TYPES_DOCUMENTOS.PRESUPUESTO,
  }),
  handleSubmit: async (values, { props }) => {
    const fetchServiceById = async (documentType: string, id: string) => {
      switch (documentType) {
        case TYPES_DOCUMENTOS.PEDIDO:
          return getPedidoById(id)
        case TYPES_DOCUMENTOS.ALBARAN:
          return getAlbaranById(id)
        default:
          return getPresupuestoById(id)
      }
    }

    const documentAsociadosIs = values.documentosSelectedIds.map(
      (element: Documento) => element.id
    )

    const documentAsociadosPdf = values.documentosSelectedIds.map(
      (element: Documento) => ({
        tipoDocumento: element.tipoDocumento,
        numero: `${element.numero}`,
        serie: `${element.serie}`,
      })
    )

    const documentPromises = values.documentosSelectedIds.map(
      (element: Documento) =>
        fetchServiceById(values.selectDocument, element.id)
    )
    const documentResponses = await Promise.all(documentPromises)

    const descuentoResponse = documentResponses.every(
      (response, index) =>
        index === 0 || response.descuento === documentResponses[0].descuento
    )
      ? documentResponses[0].descuento
      : null

    const formaPagoResponse = documentResponses.every(
      (response, index) =>
        index === 0 || response.formaPago === documentResponses[0].formaPago
    )
      ? documentResponses[0].formaPago
      : null

    const diasPagoResponse = documentResponses.every(
      (response, index) =>
        index === 0 || response.diasPago === documentResponses[0].diasPago
    )
      ? documentResponses[0].diasPago
      : null

    const observaciones =
      documentResponses
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc: string[], response: $TSMigrationFixMe) => {
          if (response.observaciones) {
            acc.push(response.observaciones)
          }
          return acc
        }, [])
        .join("\\") ?? null

    const numeroSerieAsociados =
      documentResponses
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc: string[], response: $TSMigrationFixMe) => {
          if (response.serie && response.numero) {
            acc.push(`${response.serie} - ${response.numero}`)
          }
          return acc
        }, [])
        .join(" - ") ?? null

    props.handleVariable(
      "descuento",
      descuentoResponse ?? props.valuesForm.descuento
    )
    if (formaPagoResponse) {
      const formaPagoDescription = props.formasPago?.find(
        (forma: formaPago) => {
          return formaPagoResponse === forma.id
        }
      )?.description
      props.handleVariable(
        "formaPago",
        formaPagoResponse ?? props.valuesForm.formaPago
      )
      props.handleVariable(
        "formaPagoDescription",
        formaPagoDescription ?? props.valuesForm.formaPagoDescription
      )
    }
    props.handleVariable(
      "diasPago",
      diasPagoResponse ?? props.valuesForm.diasPagoResponse
    )
    props.handleVariable(
      "observaciones",
      observaciones ?? props.valuesForm.observaciones
    )

    props.handleVariable(
      "documentosComercialesAsociados",
      `${capitalize(values.selectDocument)}: ${numeroSerieAsociados}`
    )

    const allArticulos = documentResponses.flatMap(
      (response) => response.articuloDocumentos || []
    )

    const articulosAgrupados = allArticulos.reduce(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (acc: $TSMigrationFixMe, articulo: $TSMigrationFixMe) => {
        const key = JSON.stringify({
          concepto: articulo.articulo.concepto,
          impuestoRepercutido: articulo.impuestoRepercutido,
          tarifaImpuesto: articulo.tarifaImpuesto,
        })

        if (!acc[key]) {
          acc[key] = {
            articulo: {
              ...articulo.articulo,
              id: articulo.articulo.id,
            },
            cantidad: 0,
            impuesto: articulo.impuestoRepercutido,
            tarifaImpuesto: articulo.tarifaImpuesto,
          }
        }

        acc[key].cantidad += articulo.cantidad
        return acc
      },
      {}
    )

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const listadoFinal = Object.values(articulosAgrupados).map(
      (item: $TSMigrationFixMe) => {
        return {
          concepto: item.articulo.concepto,
          id: item.articulo.id,
          precioVenta: item.articulo.precioVenta,
          cantidad: item.cantidad,
          impuesto: item.impuesto,
          tarifaImpuesto: item.tarifaImpuesto,
        }
      }
    )

    props.handleVariable(
      "documentosComercialesAsociadosId",
      documentAsociadosIs
    )

    props.handleVariable(
      "documentosComercialesAsociadosPdf",
      documentAsociadosPdf
    )

    props.handleAddArticle(listadoFinal)

    props.handleVariable("config.modalAsociar", values)
    props.onHide()
  },
})(AsociarDocumento)

export default FormAsociarDocumento
